<div class="caissier-wrapper">
    <div class="hero card-glass mb-3">
        <div class="crumb">
            <a routerLink="/utilisateur/codes" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au tableau de bord codes</a>
            <span class="crumb-current">Caissiers · {{bDescription}}</span>
        </div>
        <div class="hero-flex">
            <div>
                <p class="eyebrow">Spay · Gestion des caissiers</p>
                <h1>{{bDescription}}</h1>
                <p class="lead">Ajoutez ou éditez les caissiers autorisés sur ce compte pro.</p>
                <div class="alerts">
                    <p *ngIf="added" class="alert-text warn">Le caissier a été enregistré.</p>
                    <p *ngIf="phonexist" class="alert-text danger">Numéro déjà utilisé.</p>
                    <p *ngIf="emailexist" class="alert-text danger">Email déjà utilisé.</p>
                </div>
                <div class="cta-row mt-2">
                    <button type="button" class="btn btn-primary btn-pill" (click)="startCreate()">
                        Ajouter un caissier
                    </button>
                    <button type="button" class="btn btn-outline-light btn-pill" (click)="afficherLesCaisiers()">Rafraîchir la liste</button>
                </div>
            </div>
        </div>
    </div>

    <div class="card-glass p-3">
        <p class="eyebrow mb-1">Liste des caissiers</p>
        <h4 class="mb-3">Affectés à {{bDescription}}</h4>
        <div class="table-responsive">
            <table class="table table-borderless align-middle text-light">
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>Email</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of caisierlist">
                        <td>{{c.firstName}}</td>
                        <td>{{c.lastName}}</td>
                        <td>{{c.username}}</td>
                        <td>
                            <div class="btn-group btn-group-sm">
                                <button type="button" class="btn btn-outline-light" (click)="editer(c.id,c)">
                                    <i class="bi bi-pencil-square me-1"></i><span class="d-none d-sm-inline">Editer</span>
                                </button>
                                <button type="button" class="btn btn-outline-danger" disabled>
                                    <i class="bi bi-trash me-1"></i><span class="d-none d-sm-inline">Suppr</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="!caisierlist || caisierlist.length === 0">
                        <td colspan="4" class="text-center text-muted">Aucun caissier enregistré pour le moment.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Modal ajout/édition caissier -->
<div class="modal fade modal-glass" id="caissierModal" tabindex="-1" aria-labelledby="caissierModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <div>
            <p class="eyebrow mb-1">Spay · Caissier</p>
            <h5 class="modal-title" id="caissierModalLabel">{{ isedit ? 'Modifier un caissier' : 'Ajouter un caissier' }}</h5>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="CaissierForm" #f="ngForm" (ngSubmit)="addCaissier(f.value)">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">Nom</label>
                    <input formControlName="firstName" name="firstName" #firstName (blur)="generateEmail(firstName.value)" class="form-control" type="text">
                    <small *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="text-danger">Min. 3 caractères</small>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Prénom</label>
                    <input formControlName="lastName" name="lastName" class="form-control" type="text">
                    <small *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="text-danger">Min. 3 caractères</small>
                </div>
                <div class="col-md-12">
                    <label class="form-label">Email de connexion</label>
                    <input formControlName="email" name="email" class="form-control" type="email" (blur)="isEmail(email.value)" readonly #email>
                    <small *ngIf="emailexist" class="text-danger">Email déjà utilisé</small>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Mot de passe</label>
                    <input formControlName="password" #pass (focus)="showvalidationpart()"
                        (blur)="hidevalidationpart()" (keyup)="validateValue(pass.value)"
                        name="password" class="form-control" type="password" id="pass" required>
                    <small *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">Invalide</small>
                    <div *ngIf="validation" class="mt-2">
                        <p [ngStyle]="{'color':letterchange ? 'lightgreen' : '#ff9b9b' }" id="letter" class="small m-0">Minuscule</p>
                        <p [ngStyle]="{'color':capitalchange ? 'lightgreen' : '#ff9b9b' }" id="capital" class="small m-0">Majuscule</p>
                        <p [ngStyle]="{'color':numberchange ? 'lightgreen' : '#ff9b9b' }" id="number" class="small m-0">Chiffre</p>
                        <p [ngStyle]="{'color':symbolechange ? 'lightgreen' : '#ff9b9b' }" id="symbole" class="small m-0">Symbole</p>
                        <p [ngStyle]="{'color':lengthchange ? 'lightgreen' : '#ff9b9b' }" id="length" class="small m-0">8-16 caractères</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Confirmer le mot de passe</label>
                    <input formControlName="confirmPassword" name="confirmPassword" class="form-control" type="password" required>
                    <small *ngIf="confirmPassword.invalid && (confirmPassword.dirty|| confirmPassword.touched)" class="text-danger">Invalide ou différent</small>
                </div>
            </div>
            <div class="d-flex justify-content-end gap-2 mt-3">
                <button type="button" class="btn btn-outline-light btn-pill" data-bs-dismiss="modal" (click)="closeModal()">Annuler</button>
                <button type="submit" class="btn btn-primary btn-pill" [disabled]="!CaissierForm.valid || phonexist">Enregistrer</button>
            </div>
        </form>
      </div>
    </div>
  </div>
</div>
